import React from 'react';
import { withPrefix } from "gatsby";
import { Router, Redirect } from '@reach/router';
import Login from '../components/Login/Login';
import Overview from './overview';
import Insights from './insights';
import Partners from './partners';
import Press from './press';
import PrivateRoute from '../components/Utils/PrivateRoute';
import Chime from '../components/chime';
import Partnerships from '../components/partnerships';


import '../styles/all.scss';

const index = () => {

  return (
      <Router basepath={withPrefix("/")}>
        <Redirect from="/" to={withPrefix("/overview")} noThrow/>
        <Overview path="overview"/>
        <Insights path="insights"/>
        <Press path="press"/>
        <Partners path="partners">
          <PrivateRoute path="our-work" component={Partnerships}/>
          <PrivateRoute path="chime" component={Chime}/>
          <Login path="login"   component={Login}/>
        </Partners>
      </Router>
  )
};

export default index
  